import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LibraryMusicIcon(props: IconProps) {
    return <Icon {...props} iconKey={"library_music"}/>
}
